import type { ClaimCandidateStatus } from "@hp/types";
import { Badge, StatusPill } from "@hp/ui";
import { claimStatusDisplay } from "../lib/claimStatusDisplay";

export function ClaimStatusPill({
  status,
  counselValidatedAt,
  className,
}: {
  status: ClaimCandidateStatus;
  counselValidatedAt?: string | null;
  className?: string;
}) {
  const display = claimStatusDisplay(status, counselValidatedAt);
  if (display.useStandardPill) {
    return <StatusPill kind="claim_candidate" status={status} className={className} />;
  }
  return (
    <Badge tone={display.tone} className={className}>
      {display.label}
    </Badge>
  );
}
